import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { eBieuMauNguoiDungActionIds, IBieuMauNguoiDungActionTypes } from "../../action-types/quan-ly-bieu-mau/IBieuMauNguoiDungActions";
import { rootActions } from "../../actions/rootActions";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { bieuMauNguoiDungApi } from "../../../api/quan-ly-bieu-mau/bieuMauNguoiDungApi";
import { IBieuMauNguoiDung } from "../../../model/response/quan-ly-bieu-mau/IBieuMauNguoiDung";

const mainAction = rootActions.bieuMauNguoiDung;
export function* bieuMauNguoiDungSaga(): any {
    yield takeLatest(eBieuMauNguoiDungActionIds.LOAD_START, loadWoker);
    yield takeEvery(eBieuMauNguoiDungActionIds.SAVE_START, saveWorker);
    yield takeEvery(eBieuMauNguoiDungActionIds.DELETE_START, deleteWorker);
    yield takeEvery(eBieuMauNguoiDungActionIds.LOAD_FIELDS_BY_CHUC_NANG_START, loadFieldsByChucNang);
}

function* loadWoker(): any {
    const res: IBaseResponse = yield call(bieuMauNguoiDungApi.SelectAll);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi khi tải biểu mẫu"));
    }
}
function* saveWorker(action: IBieuMauNguoiDungActionTypes): any {
    let res: IBaseResponse;
    const payload = action.payload as IBieuMauNguoiDung;
    if (payload.id > 0){
        res = yield call(bieuMauNguoiDungApi.Update, payload.id, payload);
    } else {
        res = yield call(bieuMauNguoiDungApi.Insert, payload);
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data));
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi khi lưu biểu mẫu"));
    }
}

function* deleteWorker(action: IBieuMauNguoiDungActionTypes): any {
    const id = action.payload as number;
    const res: IBaseResponse = yield call(bieuMauNguoiDungApi.Delete, id);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi khi xóa biểu mẫu"));
    }
}

function* loadFieldsByChucNang(action: IBieuMauNguoiDungActionTypes): any {
    const ma_chuc_nang = action.payload as string;
    const res: IBaseResponse = yield call(bieuMauNguoiDungApi.SelectFieldsByChucNang, ma_chuc_nang);
    if (res.is_success) {
        yield put(mainAction.LOAD_FIELDS_BY_CHUC_NANG_SUCCESS(res.data));
    } else {
        yield put(mainAction.LOAD_FIELDS_BY_CHUC_NANG_ERROR(res.message ?? "Có lỗi khi tải các trường của chức năng"));
    }
}